import { Pipe, PipeTransform } from '@angular/core';
import { EmployeeCaseOption, LeaveHoursBanksBuckets } from '@core/models';
import { ConstantsService } from '@core/services';

@Pipe({
    name: 'replaceBankNames',
    standalone: false
})

export class ReplaceBankNamesPipe implements PipeTransform {
  constructor(private constants: ConstantsService) {}
  transform(text: string, bankBucketNames: EmployeeCaseOption | LeaveHoursBanksBuckets) {
    if (!text || !bankBucketNames) {
      return text;
    }

    // because we currently don't support 'string.replaceAll' (es2018), the 
    // following regex patterns with the global flag are used to match and 
    // replace ALL tokens

    // banks
    if (text.includes(this.constants.BANK_REPLACEMENT_TOKENS.bank1)) {
      text = text.replace(getTokenRegex(this.constants.BANK_REPLACEMENT_TOKENS.bank1),
        bankBucketNames.bank1Name ?? 
        (bankBucketNames as LeaveHoursBanksBuckets).bank1DefaultName ?? 
        this.constants.BANK_REPLACEMENT_TOKENS.bank1);
    }
    if (text.includes(this.constants.BANK_REPLACEMENT_TOKENS.bank2)) {
      text = text.replace(getTokenRegex(this.constants.BANK_REPLACEMENT_TOKENS.bank2),
        bankBucketNames.bank2Name ?? 
        (bankBucketNames as LeaveHoursBanksBuckets).bank2DefaultName ?? 
        this.constants.BANK_REPLACEMENT_TOKENS.bank2);
    }
    if (text.includes(this.constants.BANK_REPLACEMENT_TOKENS.bank3)) {
      text = text.replace(getTokenRegex(this.constants.BANK_REPLACEMENT_TOKENS.bank3),
        bankBucketNames.bank3Name ?? 
        (bankBucketNames as LeaveHoursBanksBuckets).bank3DefaultName ?? 
        this.constants.BANK_REPLACEMENT_TOKENS.bank3);
    }
    if (text.includes(this.constants.BANK_REPLACEMENT_TOKENS.bank4)) {
      text = text.replace(getTokenRegex(this.constants.BANK_REPLACEMENT_TOKENS.bank4),
        bankBucketNames.bank4Name ?? 
        (bankBucketNames as LeaveHoursBanksBuckets).bank4DefaultName ?? 
        this.constants.BANK_REPLACEMENT_TOKENS.bank4);
    }
    if (text.includes(this.constants.BANK_REPLACEMENT_TOKENS.bank5)) {
      text = text.replace(getTokenRegex(this.constants.BANK_REPLACEMENT_TOKENS.bank5),
        bankBucketNames.bank5Name ?? 
        (bankBucketNames as LeaveHoursBanksBuckets).bank5DefaultName ?? 
        this.constants.BANK_REPLACEMENT_TOKENS.bank5);
    }

    // buckets
    if (text.includes(this.constants.BUCKET_REPLACEMENT_TOKENS.bucket1)) {
      text = text.replace(getTokenRegex(this.constants.BUCKET_REPLACEMENT_TOKENS.bucket1),
        (bankBucketNames as LeaveHoursBanksBuckets).bucket1Name ?? 
        (bankBucketNames as LeaveHoursBanksBuckets).bucket1DefaultName ?? 
        this.constants.BUCKET_REPLACEMENT_TOKENS.bucket1);
    }
    if (text.includes(this.constants.BUCKET_REPLACEMENT_TOKENS.bucket2)) {
      text = text.replace(getTokenRegex(this.constants.BUCKET_REPLACEMENT_TOKENS.bucket2),
        (bankBucketNames as LeaveHoursBanksBuckets).bucket2Name ?? 
        (bankBucketNames as LeaveHoursBanksBuckets).bucket2DefaultName ?? 
        this.constants.BUCKET_REPLACEMENT_TOKENS.bucket2);
    }
    if (text.includes(this.constants.BUCKET_REPLACEMENT_TOKENS.bucket3)) {
      text = text.replace(getTokenRegex(this.constants.BUCKET_REPLACEMENT_TOKENS.bucket3),
        (bankBucketNames as LeaveHoursBanksBuckets).bucket3Name ?? 
        (bankBucketNames as LeaveHoursBanksBuckets).bucket3DefaultName ?? 
        this.constants.BUCKET_REPLACEMENT_TOKENS.bucket3);
    }
    if (text.includes(this.constants.BUCKET_REPLACEMENT_TOKENS.bucket4)) {
      text = text.replace(getTokenRegex(this.constants.BUCKET_REPLACEMENT_TOKENS.bucket4),
        (bankBucketNames as LeaveHoursBanksBuckets).bucket4Name ?? 
        (bankBucketNames as LeaveHoursBanksBuckets).bucket4DefaultName ?? 
        this.constants.BUCKET_REPLACEMENT_TOKENS.bucket4);
    }

    return text;
  }
}

function getTokenRegex(token:string): RegExp {
  // add global flag to function as 'replaceAll', since the 
  // token '@[bank*]' contains brackets (a regex char class), 
  // add escape tokens before each bracket
  return new RegExp(token.replace(/([\[\]])/g, "\\$1"), "g");
}